export default class extends Controller {
  static targets = ['parentStartDate', 'parentEndDate', 'budgetStartDate', 'budgetEndDate', 'checkbox'];

  // Lifecycle
  connect() {
    this.setOverrideSettings();
  }

  // For External API
  updateBudgetStartDate() {
    this.updateField(this.parentStartDateTarget, this.budgetStartDateTarget)
  }

  updateBudgetEndDate() {
    this.updateField(this.parentEndDateTarget, this.budgetEndDateTarget)
  }

  setOverrideSettings() {
    this.checkboxTarget.checked ? this.disableBudgetDateFields() : this.enableBudgetDateFields();
  }

  // For Internal Use
  updateField(source, destination) {
    if (this.checkboxTarget.checked) destination.value = source.value;
  }

  disableBudgetDateFields() {
    this.syncBudgetDateFieldsToParentDateFields();
    this.setDisabledAttrOnBudgetDateFields('disabled');
  }

  enableBudgetDateFields() {
    this.setDisabledAttrOnBudgetDateFields();
  }

  syncBudgetDateFieldsToParentDateFields() {
    this.budgetStartDateTarget.value = this.parentStartDateTarget.value;
    this.budgetEndDateTarget.value = this.parentEndDateTarget.value;
  }

  setDisabledAttrOnBudgetDateFields(disabled=null) {
    [this.budgetStartDateTarget, this.budgetEndDateTarget].forEach(function(field) { field.disabled = disabled });
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/budget-override-controller.js